import React, { useMemo } from 'react';
import c from 'classnames';
import { FastField, FastFieldProps } from 'formik';

import { Checkbox } from '@lyearn/ui';

import { FormCheckboxField, FormElementProps } from '../../../types';
import { checkboxStyles } from './styles';

function CheckboxField(props: FormElementProps<FormCheckboxField>) {
  const { field } = props;
  const inputProps = useMemo(() => ({ name: field.name }), [field.name]);

  return (
    <FastField name={inputProps.name}>
      {({ field: { value, onChange } }: FastFieldProps<boolean>) => (
        <Checkbox
          checked={value}
          className={c('my-1 flex-shrink-0 me-12 xs:me-4', checkboxStyles)}
          disabled={field.disabled}
          inputProps={inputProps}
          onChange={onChange}
          {...field.props}
        />
      )}
    </FastField>
  );
}

export default React.memo(CheckboxField);
